module.exports = __webpack_public_path__ + "static/img/wait-approve.433a8b47.png";